if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector(
          '[type="submit"]'
        );

        if (this.submitButton) {
          this.submitButtonText =
            this.submitButton.querySelector('span');

          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute(
              'aria-haspopup',
              'dialog'
            );
          }
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';

        this.error = false;
        this.submitting = false;
        this.form.addEventListener('input', (event) => {
          if (event.target.matches('#custom_text, [name="properties[Personalisation]"]')) {
            event.target.setCustomValidity('');
          }
        });
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (!this.form || !this.submitButton || this.submitting || this.submitButton.disabled) return;
        const quantity = this.form.elements.namedItem('quantity');
        if (quantity?.dataset.quantityUnavailable === 'true') {
          this.handleErrorMessage('The maximum quantity is already in your basket. Review your basket before adding more.');
          return;
        }
        if (quantity && !quantity.checkValidity()) {
          quantity.reportValidity();
          quantity.focus();
          return;
        }

        /*
         * Makes the personalised bone text field mandatory.
         * This only applies where the #custom_text field exists.
         */
        const customTextInput =
          this.form.querySelector('#custom_text');

        if (customTextInput) {
          customTextInput.required = true;
          customTextInput.maxLength = 22;

          if (!customTextInput.value.trim()) {
            customTextInput.setCustomValidity(
              'Please enter the text you would like on the bones.'
            );

            customTextInput.reportValidity();
            customTextInput.focus();
            return;
          }

          customTextInput.setCustomValidity('');
        }

        /*
         * Makes the Personalisation field mandatory.
         * This only applies where that field exists.
         */
        const personalisationInput =
          this.form.querySelector(
            '[name="properties[Personalisation]"]'
          );

        if (personalisationInput) {
          personalisationInput.required = true;

          if (!personalisationInput.value.trim()) {
            personalisationInput.setCustomValidity(
              'Please enter the personalisation before adding this item to your basket.'
            );

            personalisationInput.reportValidity();
            personalisationInput.focus();
            return;
          }

          personalisationInput.setCustomValidity('');
        }

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();
        this.error = false;
        this.submitting = true;
        let itemAdded = false;

        this.submitButton.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton.classList.add('loading');

        const spinner = this.querySelector(
          '.loading__spinner'
        );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          if (
            typeof this.cart.getSectionsToRender ===
            'function'
          ) {
            const sections =
              this.cart.getSectionsToRender();

            if (Array.isArray(sections)) {
              const sectionIds = sections
                .map((section) => section.id)
                .filter(Boolean);

              if (sectionIds.length) {
                formData.append(
                  'sections',
                  sectionIds.join(',')
                );
              }
            }
          }

          formData.append(
            'sections_url',
            window.location.pathname
          );

          if (
            typeof this.cart.setActiveElement ===
            'function'
          ) {
            this.cart.setActiveElement(
              document.activeElement
            );
          }
        }

        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then(async (response) => {
            const body = await response.json();
            if (!response.ok && !body.status) body.status = response.status;
            return body;
          })
          .then((response) => {
            if (response.status) {
              if (
                typeof publish === 'function' &&
                typeof PUB_SUB_EVENTS !==
                  'undefined' &&
                PUB_SUB_EVENTS.cartError
              ) {
                publish(
                  PUB_SUB_EVENTS.cartError,
                  {
                    source: 'product-form',
                    productVariantId:
                      formData.get('id'),
                    errors:
                      response.errors ||
                      response.description,
                    message: response.message,
                  }
                );
              }

              this.handleErrorMessage(
                response.description ||
                  response.message ||
                  'There was a problem adding this item to your basket.'
              );

              this.error = true;
              return;
            }

            itemAdded = true;
            this.error = false;

            if (!this.cart) {
              window.location =
                window.routes.cart_url;
              return;
            }

            let startMarker = null;

            if (
              typeof CartPerformance !==
                'undefined' &&
              typeof CartPerformance.createStartingMarker ===
                'function'
            ) {
              startMarker =
                CartPerformance.createStartingMarker(
                  'add:wait-for-subscribers'
                );
            }

            if (
              !this.error &&
              typeof publish === 'function' &&
              typeof PUB_SUB_EVENTS !==
                'undefined' &&
              PUB_SUB_EVENTS.cartUpdate
            ) {
              const publishResult = publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',
                  productVariantId:
                    formData.get('id'),
                  cartData: response,
                }
              );

              if (
                publishResult &&
                typeof publishResult.then ===
                  'function'
              ) {
                publishResult.then(() => {
                  this.measureFromMarker(
                    'add:wait-for-subscribers',
                    startMarker
                  );
                });
              } else {
                this.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              }
            }

            this.error = false;

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.renderCartContents(
                      response
                    );
                  });
                },
                { once: true }
              );

              if (
                typeof quickAddModal.hide ===
                'function'
              ) {
                quickAddModal.hide(true);
              }
            } else {
              this.renderCartContents(response);
            }
          })
          .catch((error) => {
            console.error(
              'Add to basket error:',
              error
            );

            this.error = true;

            this.handleErrorMessage(
              itemAdded
                ? 'Your item was added, but the basket display could not refresh. Open your basket to continue.'
                : 'We could not confirm whether this item was added. Please check your basket before trying again.'
            );
            this.addCartRecoveryLink();
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (itemAdded) this.cart?.classList?.remove('is-empty');
            this.submitting = false;
            // Native disabled remains owned by variant availability, not request errors.
            this.submitButton.removeAttribute('aria-disabled');

            if (spinner) {
              spinner.classList.add('hidden');
            }

            if (
              typeof CartPerformance !==
                'undefined' &&
              typeof CartPerformance.measureFromEvent ===
                'function'
            ) {
              CartPerformance.measureFromEvent(
                'add:user-action',
                event
              );
            }
          });
      }

      addCartRecoveryLink() {
        if (!this.errorMessageWrapper || this.hideErrors) return;
        const link = document.createElement('a');
        link.href = window.routes.cart_url;
        link.textContent = 'Open basket';
        link.className = 'link underlined-link';
        link.dataset.rileyRecovery = 'true';
        this.errorMessageWrapper.append(link);
      }

      renderCartContents(response) {
        if (
          !this.cart ||
          typeof this.cart.renderContents !==
            'function'
        ) {
          window.location =
            window.routes.cart_url;
          return;
        }

        if (
          typeof CartPerformance !==
            'undefined' &&
          typeof CartPerformance.measure ===
            'function'
        ) {
          CartPerformance.measure(
            'add:paint-updated-sections',
            () => {
              this.cart.renderContents(response);
            }
          );
        } else {
          this.cart.renderContents(response);
        }
      }

      measureFromMarker(name, marker) {
        if (
          !marker ||
          typeof CartPerformance ===
            'undefined' ||
          typeof CartPerformance.measureFromMarker !==
            'function'
        ) {
          return;
        }

        CartPerformance.measureFromMarker(
          name,
          marker
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;
        this.errorMessageWrapper.querySelectorAll('[data-riley-recovery]').forEach((node) => node.remove());

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (
            this.submitButtonText &&
            window.variantStrings
          ) {
            this.submitButtonText.textContent = this.closest('.riley-retail') ? 'Add to basket' : window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        if (!this.form) return null;

        return this.form.querySelector(
          '[name="id"]'
        );
      }
    }
  );
}